import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

export const useCartItemsStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      backgroundColor: '#fff',
      width: '97%',
      borderRadius: 16,
      marginBottom: theme.spacing(3),
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginBottom: 20,
      },
    },
    img: {
      maxHeight: 105,
      cursor: 'pointer',

      // [theme.breakpoints.down('sm')]: {
      //   maxHeight: 150,
      // },
    },
    contentWrapper: {
      display: 'flex',
      flexDirection: 'row',
      padding: '34px 0',
      // alignItems: 'center',
    },
    infoWrapper: {
      marginLeft: 20,
      width: '100%',
    },
    buttonsWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'end',
      minWidth: 200,
    },
    infoButtonsWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
      },
    },
    name: {
      fontSize: 20,
      fontWeight: 600,
      margin: 0,

      [theme.breakpoints.up('md')]: {
        fontSize: 34,
        lineHeight: 1,
      },
    },
    cardContent: {
      padding: '0 30px',
    },
    containerImage: {
      position: 'relative',
    },
    priceTotal: {
      color: '#181c32',
      fontSize: 32,
      fontWeight: '400',
      [theme.breakpoints.down('sm')]: {
        fontSize: 18,
      },
    },
    priceProduct: {
      color: '#181c32',
      fontSize: 20,
      fontWeight: '400',
      marginRight: 8,
      whiteSpace: 'nowrap',
      [theme.breakpoints.down('sm')]: {
        fontSize: 16,
      },
    },
    buttonDec: {
      cursor: 'pointer',
    },
    buttonCount: {
      color: '#181c32',
      borderColor: 'white',
      borderLeft: 'none',
      borderRight: 'none',
      margin: '0 2px',
      fontWeight: 400,
      fontSize: 20,
    },
    buttonInc: {
      cursor: 'pointer',
    },
    productName: {
      fontSize: 20,
      lineHeight: '26px',
      fontWeight: 400,
      color: '#181c32',
    },
    containerPrice: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: 30,
      alignItems: 'center',
    },
    containerProduct: {
      display: 'flex',
      flexDirection: 'column',
      marginRight: 14,
    },
    btnIconTitle: {
      fontsize: 16,
      color: '#7c97c0',
      fontWeight: 400,
      marginLeft: 7,
    },
    containerButton: {
      cursor: 'pointer',
      marginBottom: 24,
    },
    containerBtns: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      backgroundColor: '#a3a7b819',
      borderRadius: 4,
      marginLeft: 15,
      [theme.breakpoints.down('sm')]: {
        marginLeft: 0,
      },
    },
  })
);
